import { Injectable } from "@angular/core";
import { ShowsApi, ApiConfiguration } from "api";
import { Cache, PagedArray } from "common";
import { Show, Production } from "models";
import { LoggerService } from "@tytapp/common";

@Injectable()
export class ShowsService {
    constructor(
        private showsApi : ShowsApi,
        private apiConfig : ApiConfiguration,
        private logger : LoggerService
    ) {

    }

    cache : Cache<Show> = Cache.shared<Show>('shows', 1000 * 60 * 15, 100);
    showListCache : Cache<PagedArray<Show>> = Cache.shared<PagedArray<Show>>('shows-list', 1000 * 60 * 15, 1);
    showFeedCache : Cache<PagedArray<Production>> = Cache.shared<PagedArray<Production>>('show-feeds', 1000 * 60 * 15, 1);
    
    async all() {
        return await this.showListCache.fetch('default', async () => await this.showsApi.all().toPromise() as PagedArray<Show>);
    }

    async get(id : string) {
        return await this.cache.fetch(id, async () => await this.showsApi.get(id).toPromise() as Show);
    }

    async getPodcasts(showId : string, offset? : number, limit? : number) {
        return await this.showFeedCache.fetch(`podcasts-${showId}-page-${offset}-${limit}`, async skip => {
            return await this.showsApi.getShowPodcasts(showId, offset, limit).toPromise();
        });
    }

    async getClips(showId : string, offset? : number, limit? : number) {
        return await this.showFeedCache.fetch(`clips-${showId}-page-${offset}-${limit}`, async skip => {
            return this.showsApi.getShowClips(showId, offset, limit).toPromise();
        });
    }

    async getEpisodes(showId : string, offset? : number, limit? : number) {
        return await this.showFeedCache.fetch(`episodes-${showId}-page-${offset}-${limit}`, async skip => {
            return this.showsApi.getShowEpisodes(showId, offset, limit).toPromise();
        });
    }
}